exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1oAgFr6qHig5bL-H2LObcz{color:\"[theme:white, default:#ffffff]\"!important}", ""]);
// Exports
exports.locals = {
	"ribbonMessage": "_1oAgFr6qHig5bL-H2LObcz"
};